// Central photo asset URLs (authentic stock photography)
export const PHOTOS = {
  accraSkyline: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Accra_Skyline.jpg/1280px-Accra_Skyline.jpg',
  engineersNoc: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1200&q=80&auto=format&fit=crop',
  engineerPortrait: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800&q=80&auto=format&fit=crop',
  datacenterRacks: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&q=80&auto=format&fit=crop',
  networkCabling: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1200&q=80&auto=format&fit=crop',
  securityOps: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=1200&q=80&auto=format&fit=crop'
};

export const INDUSTRY_PHOTOS = {
  finance: 'https://images.unsplash.com/photo-1601597111158-2fceff292cdc?w=900&q=80&auto=format&fit=crop',
  healthcare: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=900&q=80&auto=format&fit=crop',
  government: 'https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?w=900&q=80&auto=format&fit=crop',
  retail: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=900&q=80&auto=format&fit=crop',
  manufacturing: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=900&q=80&auto=format&fit=crop',
  technology: 'https://images.unsplash.com/photo-1573496130407-57329f01f769?w=900&q=80&auto=format&fit=crop'
};
